import React, { useContext } from 'react';
import { List } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import OrganizationExtrasSettings from '@totem/components/settings/sections/account/OrganizationExtrasSettings';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';

import './account.css';

const Account = () => {
  const { userProfile } = useContext(UserProfileContext);

  return (
    <div styleName="container">
      {permissions.systemAdministrator.hasPermissions(userProfile) && (
        <IBTooltip content={permissions.systemAdministrator.tooltip}>
          <List>
            <OrganizationExtrasSettings />
          </List>
        </IBTooltip>
      )}
    </div>
  );
};

export default Account;
